import { AnalyticsService } from '@kfc-global/react-shared/analytics';
import { getDataLayer, isSupportedTenantCode, openClearCartModal } from 'common/utilities/utils';
import events from '@kfc-global/react-shared/analytics/Register';
import { ROUTE_URL, SELECTED_EVENT_TYPE } from 'common/constants/SharedConstants';
import DISPOSITION_CONSTANTS from '../Constants/DispositionConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { logEvent } from 'common/utilities/analyticsUtils';
/**
 *
 * @param {*} data - disposition module data - Object
 */
export const modifyData = (dispositionData, deepLinkStoreMode = false) => {
  const dispositionContent = (dispositionData.disposition && dispositionData.disposition.fields) || {};
  const { headline = [], supportedDispositions = [] } = dispositionContent;
  const contentData = {
    modalHeaderText: '',
    modalContent: {},
  };
  contentData.modalContent.orderTypes = getAvailableDisposition(supportedDispositions, deepLinkStoreMode);
  const { modalHeaderText, contentText, infoObject } = getModalContent(headline);
  contentData.modalHeaderText = modalHeaderText;
  contentData.modalContent.contentText = contentText;
  contentData.modalContent.infoObject = infoObject;
  return contentData;
};

/**
 *
 * @param {*} avilableDispositionData - all disposition options
 */

const getAvailableDisposition = (avilableDispositionData, deepLinkStoreMode) => {
  const allDisposition = [];
  for (const disposition of avilableDispositionData) {
    const selectedDisposition = disposition?.fields?.name?.split('-');
    const selectedDispositionType = selectedDisposition[selectedDisposition.length - 1].trim().toUpperCase();
    if (deepLinkStoreMode && selectedDispositionType?.includes(DISPOSITION_CONSTANTS.DISPOSITION_TYPE.TYPE_DELIVERY)) {
      continue;
    }
    const { buttonText = '', selectDefault = false, name: type, showOption = true, id = '' } = disposition.fields;
    allDisposition.push({ buttonText, selectDefault, type, showOption, id });
  }
  return allDisposition;
};
/**
 *
 * @param {*} modalData data for modal
 */
const getModalContent = modalData => {
  const {
    headline: contentText = '',
    subHeadline = '',
    subHeadlineType = '',
    title: modalHeaderText = '',
  } = modalData[0].fields || {};
  return {
    modalHeaderText,
    contentText,
    infoObject: {
      type: subHeadlineType,
      infoText: subHeadline,
    },
  };
};

/**
 * Method to set analytics items in the data layer object
 */
export const setAnalyticsData = async analyticsData => {
  const analyticsItems = [];
  analyticsItems.push({
    event: 'orderType',
    dispositionSelected: analyticsData.selectedDispositionType,
  });
  await AnalyticsService.registerEvent(
    undefined,
    {
      data: analyticsItems[0],
    },
    getDataLayer,
  );
};

export const checkCartStatus = (cartData, userOrderStateDispatch, confirmCallBack, shouldSkipCartCheck) => {
  const { CLEAR_CART_CONFIRM_CANCEL_MODAL, SHOW_CLEAR_CART_ALERT } = START_ORDER_CONSTANTS;
  if (cartData?.foodLines?.length && !shouldSkipCartCheck) {
    openClearCartModal(
      userOrderStateDispatch,
      {},
      SHOW_CLEAR_CART_ALERT,
      CLEAR_CART_CONFIRM_CANCEL_MODAL,
      confirmCallBack,
    );
  } else {
    confirmCallBack();
  }
};

export const checkAndRedirectToHomepage = (isDeeplinkMode, history) => {
  if (isDeeplinkMode) {
    history?.push({
      pathname: ROUTE_URL.HOME_PAGE,
    });
  }
};

export const orderTypeAnalytics = async (orderType = 'NA', userType = 'NA') => {
  await AnalyticsService.registerEvent(
    events?.selectOrderType?.name,
    {
      data: {
        event: SELECTED_EVENT_TYPE,
        disposition: orderType,
        userType,
      },
    },
    getDataLayer,
  );
};

export const getOrderTypeAnalytics = (orderType = 'NA', userType = 'NA') =>
  isSupportedTenantCode() && orderTypeAnalytics(orderType, userType);

export const orderTypeAnalyticsHandler = (payload, disableOrderTypeAnalytic) => {
  if (!disableOrderTypeAnalytic) {
    logEvent(events?.selectOrderType?.name, { ...payload });
  }
};
